module.exports = __webpack_public_path__ + "static/media/oberflex-cheneastrakannoir-2560x1440.9855ec83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneastrakannoir-2560x1440.jpg
// module id = 993
// module chunks = 37